
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as info0sXbIZ2zwORbDs2yB4R_K0i9_451kxY6WwhHpj_45p9Ki10Meta } from "/app/pages/info.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as printTF4iLIZ9pZ_45swIsNGuiC41sYvL9WK8DnB2lyo_MM4AgMeta } from "/app/pages/print.vue?macro=true";
import { default as notfoundRX4gm93WVWBegUJy3SXLYDuMwpiFYKebgE_45P8wDAvYUMeta } from "/app/pages/notfound.vue?macro=true";
import { default as overview21fXdTJj_Mr9OULTEcdfESvh2SWhybUZ3dnqV6jHD4sMeta } from "/app/pages/overview.vue?macro=true";
import { default as privacyPolicym_Ep_45rQkvraqUppAPb1OBvA3DeGrjWz_EGiyVp8RR3UMeta } from "/app/pages/privacyPolicy.vue?macro=true";
export default [
  {
    name: "info",
    path: "/info",
    component: () => import("/app/pages/info.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "print",
    path: "/print",
    component: () => import("/app/pages/print.vue")
  },
  {
    name: "notfound",
    path: "/notfound",
    component: () => import("/app/pages/notfound.vue")
  },
  {
    name: "overview",
    path: "/overview",
    component: () => import("/app/pages/overview.vue")
  },
  {
    name: "privacyPolicy",
    path: "/privacyPolicy",
    component: () => import("/app/pages/privacyPolicy.vue")
  }
]